export const SET_AVATAR_FILE_NAME = 'avatar/filename';
export const SET_USE_GRAVATAR = 'avatar/useGravatar';

